import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InternalHeader from "../../../../components/Header/InternalHeader";
import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from '@mui/material'
import Sidebar from '../../components/Sidebar'
import BusinessForm from '../../components/BusinessForm'
import * as uiActions from 'modules/UI/actions'

const BusinessCreator = () => {
  const dispatch = useDispatch()
  const userReadOnly = useSelector(state => state.user.details?.lifecycleStatus === 'SUSPENDED')
  const showForm = useSelector(state => state.ui.showBusinessForm)

  useEffect(() => {
    if (!userReadOnly) dispatch(uiActions.showBusinessForm())
  }, [dispatch, userReadOnly])

  return (
    <>
      <Sidebar />
      <main style={{ marginLeft: 300, minHeight: '90vh' }}>
        <InternalHeader title="Welcome to HiddenUnderGround" />
        <Box p={3}>
          <Grid container spacing={3} alignItems="stretch">
            <Grid item sm={3}>
              <Card>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Create business
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    Create business and start creating new offers
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button disabled={userReadOnly} color="primary" onClick={() => dispatch(uiActions.showBusinessForm())}>
                    Add business
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </main>
      {/* {console.log("business form", showForm)} */}
      {showForm && !userReadOnly && <BusinessForm />}
    </>
  )
}

export default BusinessCreator
